import styled from 'styled-components';

type RecaptchaProps = {
  _spacing?: number;
  _textColor?: string;
  _linksColor?: string;
  _fontSize?: number;
};

export const Recaptcha = ({
  _spacing,
  _textColor,
  _linksColor,
  _fontSize
}: RecaptchaProps) => {
  const policyLink = (
    <a
      href="https://policies.google.com/privacy"
      target="_blank"
      rel="nofollow noreferrer noopener"
    >
      Privacy Policy
    </a>
  );
  const termsLink = (
    <a
      href="https://policies.google.com/terms"
      target="_blank"
      rel="nofollow noreferrer noopener"
    >
      Terms of Service
    </a>
  );

  return (
    <Container
      _spacing={_spacing}
      _textColor={_textColor}
      _linksColor={_linksColor}
      _fontSize={_fontSize}
    >
      This site is protected by reCAPTCHA and the Google {policyLink} and{' '}
      {termsLink} apply.
    </Container>
  );
};

const Container = styled.div<RecaptchaProps>`
  line-height: 1.2;
  margin-top: ${({ _spacing }) => _spacing}px;
  color: ${({ _textColor }) => _textColor};
  font-size: ${({ _fontSize }) => _fontSize}px;
  a {
    color: ${({ _linksColor }) => _linksColor};
    text-decoration: underline;
    cursor: pointer;
  }
`;
